import {
  FiAlertCircle, FiArchive, FiBarChart2, FiBell, FiBook, FiBookOpen,
  FiBriefcase, FiCalendar, FiCheckSquare, FiClipboard, FiClock,
  FiCreditCard, FiDollarSign, FiFileText, FiGrid, FiKey, FiLink,
  FiLock, FiMapPin, FiMessageSquare, FiPackage, FiPlusCircle,
  FiRepeat, FiSend, FiSettings, FiShield, FiShoppingBag, FiSliders,
  FiTool, FiTruck, FiUser, FiUserPlus, FiUsers,
} from 'react-icons/fi';
import { ROUTE_LINKS } from '../router/navigation';

// Configure icons by the final submodule label in navigation.js route keys.
export const QUICK_LINK_ICONS = {
  'Request for Leave': FiCheckSquare,
  'Reports': FiBarChart2,
  'Mark Attendance': FiClock,
  'Holiday Calendar': FiCalendar,
  'Leave Report': FiCalendar,
  'Announcements': FiBell,
  'Org Chart': FiUsers,
  'My Profile': FiUser,
  'Announcements Configuration': FiBell,
  'Profile': FiUser,
  'Org Tables Excel Load': FiGrid,
  'Calendar Events Configuration': FiCalendar,
  'Role Services Configuration': FiSettings,
  'Roles & Permissions': FiShield,
  'Employee Information': FiUser,
  'Current Employment': FiBriefcase,
  'Employee Shifts Mapping': FiClock,
  'Shift Mapping': FiClock,
  'Previous Employment': FiBriefcase,
  'Education Records': FiBookOpen,
  'Employee Documents': FiFileText,
  'Account Details': FiCreditCard,
  'Emergency Info': FiAlertCircle,
  'Assets & Access': FiKey,
  'Position History': FiBriefcase,
  'Onboarding': FiUserPlus,
  'Shifts Master Configuration': FiClock,
  'Polls Configuration': FiBarChart2,
  'Polls': FiBarChart2,
  'Week Work Schedule': FiCalendar,
  'Customer Complaints': FiMessageSquare,
  'Create Customer Complaint': FiPlusCircle,
  'Complaints Checklist Configuration': FiClipboard,
  'Complaints Checklist': FiClipboard,
  'Approval Rules': FiCheckSquare,
  'Net Price Rules': FiSliders,
  'Net Price Configuration': FiSliders,
  'PMC Cost Heads': FiDollarSign,
  'Terms Library': FiBook,
  'Quotation': FiFileText,
  'Quotations': FiFileText,
  'Record Inventory': FiArchive,
  'Stock Position': FiPackage,
  'Stock Journal': FiBookOpen,
  'Allocate to Customer': FiSend,
  'Stock Transfer': FiRepeat,
  'Reorder Alerts': FiAlertCircle,
  'Inventory Management': FiPackage,
  'Units of Measure': FiTool,
  'Product Catalogue': FiShoppingBag,
  'Inventory Location': FiMapPin,
  'Product Vendor': FiTruck,
  'Local Policy': FiFileText,
  'Local Claims': FiDollarSign,
  'Local Claims Report': FiBarChart2,
  'Expense Policy': FiFileText,
  'Tickets': FiClipboard,

  // Static shortcuts and legacy quick-link labels.
  'Leave Management': FiCheckSquare,
  'Change Password': FiLock,
  'Holidays': FiCalendar,
  'Leave Requests': FiCalendar,
};
export const DefaultQuickLinkIcon = FiLink;
export const ConfigureQuickLinkIcon = FiSettings;
export const normalizePreferenceKey = (key) => String(key).replace(/[\s_-]/g, '').toLowerCase();

export function getQuickLinks(preferences) {
  const values = {};
  function collect(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return;
    Object.entries(value).forEach(([key, child]) => {
      if (child && typeof child === 'object') collect(child);
      else values[normalizePreferenceKey(key)] = child;
    });
  }
  collect(preferences);
  return Array.from({ length: 8 }, (_, index) => {
    const key = 'quicklink' + (index + 1);
    const value = typeof values[key] === 'string' ? values[key].trim() : '';
    const parts = value.split('|||');
    const legacyName = Object.entries(ROUTE_LINKS).find(([, route]) => route === value)?.[0];
    const name = parts.length === 2 ? parts[0] : legacyName;
    const to = (parts.length === 2 ? parts[1] : legacyName ? value : '').trim();
    const label = name?.split('::').pop()?.trim();
    return label && to.startsWith('/') && !to.startsWith('//') && !/[\\\s]/.test(to)
      ? { key, label, to }
      : { key, label: 'Configure', to: '' };
  });
}
